import React, { Component } from 'react';
import { connect } from 'react-redux';
import RoundedModal from 'components/Global/RoundedModal/RoundedModal.jsx';
import AccountSwitcher from '@bit/knotchinc.web-react-components.account-switcher';
import { switchAccount } from './actions';

class AccountSwitchModal extends Component {
  componentWillMount() {
    document.body.scrollTop = 0;
  }
  render() {
    const { isOpen, close, accounts, switchUserAccount } = this.props;

    return (
      <RoundedModal fullWidth close={close} isOpen={isOpen} title="Switch Account">
        <AccountSwitcher accounts={accounts} switchUserAccount={switchUserAccount} />
      </RoundedModal>);
  }
}

function mapStateToProps({ Account: { data } }) {
  return {
    accounts: data.available_accounts,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    switchUserAccount: (accountId) => dispatch(switchAccount(accountId)),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AccountSwitchModal);
